import Styled from "./styles";
import MainContainer from "../../common/MainContainer";
import { Grid } from "@mui/material";
import SubHeading from "../../common/SubHeadings";
import IconComponent from "../../common/Icons";
import { useSelector } from "react-redux";

const services = [
  {
    icon: "FaCode",
    title: "Web Development",
    desc: "Custom web applications built with modern technologies and best practices for optimal performance.",
  },
  {
    icon: "FaPalette",
    title: "Web Design",
    desc: "Beautiful, responsive designs that engage users and provide exceptional user experiences across all devices.",
  },
  {
    icon: "FaCogs",
    title: "Maintenance & Support",
    desc: "Ongoing maintenance and support services to keep your website secure, updated, and running smoothly.",
  },
  {
    icon: "FaMobile",
    title: "Mobile Optimization",
    desc: "Mobile-first approach ensuring your website looks and performs perfectly on all screen sizes.",
  },
  {
    icon: "FaRocket",
    title: "Performance Optimization",
    desc: "Speed optimization and performance tuning to deliver lightning-fast loading times.",
  },
  {
    icon: "FaShieldAlt",
    title: "Security & SEO",
    desc: "Comprehensive security measures and SEO optimization to protect and promote your online presence.",
  },
];
const Services = () => {
  const theme = useSelector(({ config }) => config?.theme);
  return (
    <Styled id="services">
      <MainContainer padding="10px 0 10px 0">
        <Grid container className="services-container">
          <SubHeading fpart="What we offer" spart="Services" sColSwap={true} />
          {services?.map((service, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className="service-item"
              key={index}
            >
              <div
                className="service-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="service-icon">
                  <IconComponent
                    iconName={service?.icon}
                    iconColor={theme?.colors?.["0"]}
                    avtarObjs={{ bgColor: theme?.colors?.["2"], width: "80px" }}
                  />
                </div>
                <div className="service-content">
                  <h3 className="service-title">{service?.title}</h3>
                  <p className="service-desc">{service?.desc}</p>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </MainContainer>
    </Styled>
  );
};

export default Services;
